import React, { useState, useEffect } from "react";
import { Button } from "antd";
import styled from "styled-components";
import { TableLayoutData, DetailFields } from "../../styledElements";
import {
  lengthUnit,
  weightUnit,
} from "../../../Utils/Constant/MeasurementUnitList";

// const CustomBackground = styled.div`
//   width: 100%;
//   overflow-x: hidden;
//   padding-bottom: 12px;

//   .grid-container {
//     display: grid;
//     width: 100%;
//     border-bottom: 1px solid #f2c2c0;
//   }

//   .grid-header,
//   .grid-cell {
//     word-break: break-word;
//   }

//   .grid-header {
//     background-color: #fbe0de;
//     text-align: center;
//     padding: 10px 8px;
//     font-weight: 600;
//     font-size: 15px;
//   }

//   .param-col {
//     text-align: left;
//     padding-left: 10px;
//   }

//   .grid-cell {
//     background: #fff;
//     padding: 10px;
//     text-align: center;
//   }
// `;

const CustomBackground = styled.div`
  width: 100%;
  overflow-x: auto;   // changed from hidden
  overflow-y: hidden;
  padding-bottom: 12px;

  .grid-container {
    display: grid;
    width: max-content; // important
    min-width: 100%;
    border-bottom: 1px solid #f2c2c0;
  }

  .grid-header,
  .grid-cell {
    word-break: break-word;
    min-width: 140px; // give each solution column fixed width
  }

  .grid-header {
    background-color: #fbe0de;
    text-align: center;
    padding: 10px 8px;
    font-weight: 600;
    font-size: 15px;
  }

  .param-col {
    text-align: left;
    padding-left: 10px;
    min-width: 250px; // fixed parameter column
    position: sticky;
    left: 0;
    z-index: 2;
    background: #fbe0de;
  }

  .grid-cell {
    background: #fff;
    padding: 10px;
    text-align: center;
  }
`;

const PARAMETERS = [
  "Trim Loss %",
  "Net Trim Loss % (Incl. Edge Trim)",
  "Fulfillment (%)",
  "Trim Weight",
  "Avg. Deckle Utilized",
  "Planned Order Weight",
  "Suggested Production Weight",
  "Excess %",
  "Shortfall %",
  "Stock Weight (Suggested/ Req.)",
  "Unique Patterns",
  "Total Sets",
  "Total Orders",
  "Order Fully Fulfilled",
  "Orders Partially Fulfilled",
  "Completely Unfulfilled Orders",
];

export default function CreateNewSolCompare({
  // newSummaryData,
  // summary,
  jobCardDetailsList = [],
  onAccept,
  setSolutionId,
  jobIndex,
  isMultistage = false,
}) {
  const [dataSource, setDataSource] = useState([]);

  // useEffect(() => {
  //   if (jobIndex === -1) return;

  //   const emptyParams = PARAMETERS.reduce((acc, p) => {
  //     acc[p] = 0;
  //     return acc;
  //   }, {});

  //   const mapSummaryToParams = (summarySet, jobKey) => {
  //     const machineId = summarySet?.group?.machines?.[0]?.machine_id;
  //     const rewinderId =
  //       summarySet?.group?.machines?.[0]?.rewinder_id || null;

  //     const deckleUnitKey =
  //       summarySet?.group?.machines?.[0]?.units?.deckle_size_ub;

  //     const deckleUnit =
  //       lengthUnit?.[deckleUnitKey]?.displayName?.toUpperCase() || "";

  //     const jobcard = summarySet?.[jobKey]?.data?.summary;

  //     const avgDeckle =
  //       summarySet?.[jobKey]?.data?.summary?.[
  //         `avg_utilized_deckle_${machineId}`
  //       ]?.toFixed?.(3) ?? 0;

  //     const avgDeckleMulti =
  //       summarySet?.[jobKey]?.data?.summary?.[
  //       `avg_utilized_deckle_without_trim_${rewinderId}`
  //       ] ?? 0;

  //     return {
  //       ...emptyParams,

  //       "Trim Loss %": `${(jobcard?.match_trim_loss_percentage ?? 0).toFixed(3)}%`,
  //       "Net Trim Loss %": `${(jobcard?.net_trim_loss_percentage ?? 0).toFixed(3)}%`,
  //       "Fulfillment (%)": `${(jobcard?.requirement_fulfilled_percentage ?? 0).toFixed(3)}%`,

  //       "Trim Weight": `${jobcard?.total_net_trim_loss ?? 0}`,

  //       "Avg. Deckle Utilized": `${isMultistage ? avgDeckleMulti : avgDeckle
  //         } ${deckleUnit}`,

  //       "Planned Order Weight": `${(
  //         (jobcard?.total_weight_requirement ?? 0) -
  //         (jobcard?.stock_weight_requirement ?? 0)
  //       ).toFixed(2)}`,

  //       "Suggested Production Weight": jobcard?.job_card_weight ?? 0,

  //       "Excess %": jobcard?.fulfilled_requirement_weight
  //         ? `${(
  //           ((jobcard?.excess_orders_weight ?? 0) /
  //             (jobcard?.total_weight_requirement ?? 1)) *
  //           100
  //         ).toFixed(2)}%`
  //         : "0%",

  //       "Shortfall %": jobcard?.fulfilled_requirement_weight
  //         ? `${(
  //           ((jobcard?.shortfall_orders_weight ?? 0) /
  //             jobcard?.fulfilled_requirement_weight) *
  //           100
  //         ).toFixed(2)}%`
  //         : "0%",

  //       "Stock Weight (Suggested/ Req.)": `${jobcard?.stock_requirement_fulfilled ?? 0}/${jobcard?.stock_weight_requirement ?? 0}`,

  //       "Unique Patterns":
  //         jobcard?.unique_partitions ??
  //         `${jobcard?.unique_rewinding_partitions ?? 0}+${jobcard?.unique_cutting_patterns ?? 0}`,

  //       "Total Sets":
  //         jobcard?.total_partitions ??
  //         jobcard?.total_rewinding_partitions ??
  //         0,

  //       "Total Orders": jobcard?.total_orders ?? 0,
  //       "Order Fully Fulfilled": jobcard?.orders_fully_fulfilled ?? 0,
  //       "Orders Partially Fulfilled":
  //         jobcard?.orders_partially_fulfilled ?? 0,
  //       "Completely Unfulfilled Orders":
  //         jobcard?.orders_completely_unfulfilled ?? 0,
  //     };
  //   };

  //   let ds = [];

  //   // Existing summary (dynamic)
  //   const jobData = summary?.[jobIndex]?.jobcard;

  //   if (!jobData) return;

  //   // loop all solution_n keys
  //   Object.keys(jobData)?.forEach((innerKey) => {
  //     if (
  //       innerKey.startsWith("solution_") &&
  //       jobData?.[innerKey]
  //     ) {
  //       ds.push({
  //         type: "existing",
  //         jobIndex: jobIndex,
  //         innerKey,
  //         raw: jobData,
  //         data: mapSummaryToParams(jobData, innerKey),
  //       });
  //     }
  //   });

  //   //  Append newSummaryData dynamically
  //   if (newSummaryData) {
  //     const sol1List =
  //       newSummaryData?.solution1?.[jobIndex]
  //         ?.newlyCreatedJobCardsDetails || [];

  //     const sol2List =
  //       newSummaryData?.solution2?.[jobIndex]
  //         ?.newlyCreatedJobCardsDetails || [];

  //     sol1List.forEach((item) => {
  //       if (!item?.jobcard) return;

  //       ds.push({
  //         type: "new_solution",
  //         displayKey: "New Solution 1",
  //         innerKey: "solution_1",
  //         raw: item.jobcard,
  //         data: mapSummaryToParams(item.jobcard, "solution_1"),
  //       });
  //     });

  //     sol2List.forEach((item) => {
  //       if (!item?.jobcard) return;

  //       ds.push({
  //         type: "new_solution",
  //         displayKey: "New Solution 2",
  //         innerKey: "solution_2",
  //         raw: item.jobcard,
  //         data: mapSummaryToParams(item.jobcard, "solution_2"),
  //       });
  //     });
  //   }

  //   setDataSource(ds);
  // }, [
  //   // summary, newSummaryData, 
  //   jobIndex, jobCardDetailsList]);

  useEffect(() => {

    if (jobIndex === -1) return;

    const emptyParams = PARAMETERS.reduce((acc, p) => {
      acc[p] = 0;
      return acc;
    }, {});

    const mapSummaryToParams = (summarySet, jobKey) => {

      const machineId =
        summarySet?.group?.machines?.[0]?.machine_id;

      const rewinderId =
        summarySet?.group?.machines?.[0]?.rewinder_id || null;

      const deckleUnitKey =
        summarySet?.group?.machines?.[0]?.units?.deckle_size_ub;

      const deckleUnit =
        lengthUnit?.[deckleUnitKey]
          ?.displayName
          ?.toUpperCase() || "";

      const jobcard =
        summarySet?.[jobKey]?.data?.summary;

      const avgDeckle =
        summarySet?.[jobKey]?.data?.summary?.[
          `avg_utilized_deckle_${machineId}`
        ]?.toFixed?.(3) ?? 0;

      const avgDeckleMulti =
        summarySet?.[jobKey]?.data?.summary?.[
        `avg_utilized_deckle_without_trim_${rewinderId}`
        ] ?? 0;

      return {

        ...emptyParams,

        "Trim Loss %":
          `${(jobcard?.match_trim_loss_percentage ?? 0).toFixed(3)}%`,

        "Net Trim Loss % (Incl. Edge Trim)":
          `${(jobcard?.net_trim_loss_percentage ?? 0).toFixed(3)}%`,

        "Fulfillment (%)":
          `${(jobcard?.requirement_fulfilled_percentage ?? 0).toFixed(3)}%`,

        "Trim Weight":
          `${jobcard?.total_net_trim_loss ?? 0}`,

        "Avg. Deckle Utilized":
          `${isMultistage ? avgDeckleMulti : avgDeckle} ${deckleUnit}`,

        "Planned Order Weight":
          `${(
            (jobcard?.total_weight_requirement ?? 0) -
            (jobcard?.stock_weight_requirement ?? 0)
          ).toFixed(2)}`,

        "Suggested Production Weight":
          jobcard?.job_card_weight ?? 0,

        "Excess %":
          jobcard?.fulfilled_requirement_weight
            ? `${(
              (
                (jobcard?.excess_orders_weight ?? 0) /
                (jobcard?.total_weight_requirement ?? 1)
              ) * 100
            ).toFixed(2)}%`
            : "0%",

        "Shortfall %":
          jobcard?.fulfilled_requirement_weight
            ? `${(
              (
                (jobcard?.shortfall_orders_weight ?? 0) /
                jobcard?.fulfilled_requirement_weight
              ) * 100
            ).toFixed(2)}%`
            : "0%",

        "Stock Weight (Suggested/ Req.)":
          `${jobcard?.stock_requirement_fulfilled ?? 0}/${jobcard?.stock_weight_requirement ?? 0}`,

        "Unique Patterns":
          jobcard?.unique_partitions ??
          `${jobcard?.unique_rewinding_partitions ?? 0}+${jobcard?.unique_cutting_patterns ?? 0}`,

        "Total Sets":
          jobcard?.total_partitions ??
          jobcard?.total_rewinding_partitions ??
          0,

        "Total Orders":
          jobcard?.total_orders ?? 0,

        "Order Fully Fulfilled":
          jobcard?.orders_fully_fulfilled ?? 0,

        "Orders Partially Fulfilled":
          jobcard?.orders_partially_fulfilled ?? 0,

        "Completely Unfulfilled Orders":
          jobcard?.orders_completely_unfulfilled ?? 0,
      };
    };

    let ds = [];

    const currentJob = jobCardDetailsList?.[jobIndex];

    // ORIGINAL SOLUTIONS
    const originalJobcard = currentJob?.jobcard;

    Object.keys(originalJobcard || {}).forEach(
      (innerKey) => {
        if (
          innerKey.startsWith("solution_") &&
          originalJobcard?.[innerKey]
        ) {

          ds.push({
            type: "existing",
            innerKey,
            raw: originalJobcard,
            displayKey: `Solution ${ds.length + 1}`,
            jobIndex: jobIndex,
            data: mapSummaryToParams(
              originalJobcard,
              innerKey
            ),
          });
        }
      }
    );

    // NEWLY CREATED SOLUTIONS
    const newJobcards = currentJob?.newlyCreatedJobCardsDetails || [];

    newJobcards.forEach((newItem) => {

      const newJobcard = newItem?.jobcard;

      if (!newJobcard) return;

      Object.keys(newJobcard || {}).forEach(
        (innerKey) => {

          if (
            innerKey.startsWith("solution_") &&
            newJobcard?.[innerKey]
          ) {
            ds.push({
              type: "new_solution",
              innerKey,
              raw: newJobcard,
              displayKey:
                innerKey === "solution_1"
                  ? "New Solution 1"
                  : "New Solution 2",

              data: mapSummaryToParams(
                newJobcard,
                innerKey
              ),
            });
          }
        }
      );
    });

    setDataSource(ds);

  }, [jobCardDetailsList, jobIndex, isMultistage]);

  const handleAccept = (item, index) => {
    setSolutionId(index.toString());

    // const solID =
    //   item.type === "existing"
    //     ? item.solutionKey
    //     : item.type === "new_solution1"
    //     ? "solution1"
    //     : "solution2";

    let solID;

    if (item.type === "existing") {
      solID = item.solutionKey; // real backend key
    } else {
      solID = {
        parent: item.parent,        // solution1 / solution2
        variant: item.childIndex,   // 0 / 1
      };
    }

    onAccept(solID);
  };

  const getStatus = (item) => {
    return item?.raw?.[item.innerKey];
  };

  // const gridTemplateColumns = `250px repeat(${dataSource.length}, 1fr)`;
  const gridTemplateColumns = `250px repeat(${dataSource.length}, 140px)`;

  return (
    <CustomBackground>
      <TableLayoutData>
        <DetailFields>
          <div>
            <div
              className="grid-container"
              style={{ gridTemplateColumns }}
            >
              <div className="grid-header param-col">Parameters</div>

              {dataSource.map((item, index) => {

                const status = item?.raw?.[item?.innerKey];
                const hasAcceptedSolution = dataSource?.some((item) => item?.raw?.[item?.innerKey]?.status === "accept");

                return (
                  <div
                    key={index}
                    className="grid-header"
                  >
                    <div>
                      {item?.type === "existing"
                        ? `Solution ${index + 1}`
                        : item?.displayKey}
                    </div>

                    {/* ACCEPTED */}
                    {status?.status === "accept" ? (
                      <span
                        style={{
                          color: "green",
                          fontSize: "12px",
                          marginTop: "6px",
                        }}
                      >
                        Accepted
                      </span>

                    ) : status?.status === "reject" ? (

                      /* REJECTED */
                      <span
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "6px",
                        }}
                      >
                        Rejected
                      </span>

                    ) : (

                      /* SHOW ACCEPT BUTTON ONLY IF
                         NO OTHER SOLUTION IS ACCEPTED */
                      !hasAcceptedSolution &&
                      status?.status === "open" &&
                      Object.keys(status?.data?.summary || {}).length > 0 && (
                        <Button
                          style={{ marginTop: "6px" }}
                          className="themeBtn"
                          onClick={() =>
                            handleAccept(item, index + 1)
                          }
                        >
                          Accept
                        </Button>
                      )

                    )}
                  </div>
                );
              })}
            </div>

            {PARAMETERS.map((param, r) => (
              <div
                key={r}
                className="grid-container"
                style={{ gridTemplateColumns }}
              >
                <div className="grid-header param-col">{param}</div>

                {dataSource.map((item, c) => (
                  <div key={c} className="grid-cell">
                    {item.data[param]}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </DetailFields>
      </TableLayoutData>
    </CustomBackground>
  );
}